export const ISSUE_STATUS_NEW = 1;
export const ISSUE_STATUS_UNASSIGNED = 2;
export const ISSUE_STATUS_ASSIGNED = 3;
export const ISSUE_STATUS_WORK = 4;
export const ISSUE_STATUS_CANCELLED = 5;
export const ISSUE_STATUS_COMPLETE = 6;
